import React, { useState } from "react";
import { CgClose } from "react-icons/cg";
import { FaCloudUploadAlt } from "react-icons/fa";
import { addDoc, collection } from "firebase/firestore";
import { db } from "../../firebase";
import DisplayImage from "../DisplayImage";
import { MdDelete } from "react-icons/md";
import { toast } from "react-toastify";
import { v4 as uuidv4 } from "uuid";
import {
  getDownloadURL,
  getStorage,
  ref,
  uploadBytesResumable,
} from "firebase/storage";
import "../../css/Admin-Courses/UploadCourses.css";
import Spinner from "../Spinner";

const UploadCourses = ({ onClose, fetchData }) => {
  const [loading, setLoading] = useState(false);
  const [uploadCourseLogo, setUploadCourseLogo] = useState(0);
  const [uploadCourseCertificates, setUploadCourseCertificates] = useState(0);
  const [data, setData] = useState({
    courseName: "",
    courseInstitute: "",
    courseYear: "",
    courseLogo: [],
    courseCertificates: [],
  });
  const [fullScreenImage, setFullScreenImage] = useState("");
  const [openFullScreenImage, setOpenFullScreenImage] = useState(false);

  const handleOnChange = (e) => {
    const { name, value } = e.target;
    setData((pre) => ({
      ...pre,
      [name]: value,
    }));
  };

  async function handleUploadLogo(e) {
    setLoading(true);
    const image = e.target.files[0];
    return new Promise((resolve, reject) => {
      const storage = getStorage();
      const filename = `${data?.courseName}-${image.name}-${uuidv4()}`;
      const storageRef = ref(storage, filename);
      const uploadTask = uploadBytesResumable(storageRef, image);
      uploadTask.on(
        "state_changed",
        (snapshot) => {
          const progress =
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
            setUploadCourseLogo(progress);
          console.log("Upload is " + progress + "% done");
        },
        (error) => {
          reject(error);
        },
        () => {
          getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
            resolve(downloadURL);
            //console.log(downloadURL);
            setData((prev) => ({
              ...prev,
              courseLogo: [...(prev.courseLogo || []), downloadURL],
            }));
            setLoading(false);
          });
        }
      );
      setLoading(false);
    });
  }

  async function handleUploadCertificates(e) {
    setLoading(true);
    const video = e.target.files[0];
    return new Promise((resolve, reject) => {
      const storage = getStorage();
      const filename = `${data?.courseName}-${video.name}-${uuidv4()}`;
      const storageRef = ref(storage, filename);
      const uploadTask = uploadBytesResumable(storageRef, video);
      uploadTask.on(
        "state_changed",
        (snapshot) => {
          const progress =
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          console.log("Image Upload is " + progress + "% done");
          setUploadCourseCertificates(progress)
        },
        (error) => {
          reject(error);
        },
        () => {
          getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
            resolve(downloadURL);
            //console.log(downloadURL);
            setData((prev) => ({
              ...prev,
              courseCertificates: [...(prev.courseCertificates || []), downloadURL],
            }));
            setLoading(false);
          });
        }
      );
      setLoading(false);
    });
  }

  const handleDeleteLogo = (index) => {
    const newLogos = [...data.courseLogo];
    newLogos.splice(index, 1);
    setData((pre) => ({
      ...pre,
      courseLogo: newLogos,
    }));
  };

  const handleDeleteCertificates= (index) => {
    const newCertificates= [...data.courseCertificates];
    newCertificates.splice(index, 1);
    setData((pre) => ({
      ...pre,
      courseCertificates: newCertificates,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    await addDoc(collection(db, "courses"), data);
    setLoading(false);
    toast.success("Course Added");
    fetchData();
    onClose();
  };
  if (loading) {
    return <Spinner />;
  }

  return (
    <div className="overlay">
      <div className="edit-product-modal">
        <div className="modal-header">
          <h2 className="title">Add courses</h2>
          <div className="close-icon" onClick={onClose}>
            <CgClose />
          </div>
        </div>
        <form className="form" onSubmit={handleSubmit}>
          <label htmlFor="courseName">Courses Name :</label>
          <input
            type="text"
            id="courseName"
            placeholder="Enter Course name"
            value={data.courseName}
            name="courseName"
            onChange={handleOnChange}
            className="input"
            required
          />
          <label htmlFor="courseInstitute">Institute Name :</label>
          <input
            type="text"
            id="courseInstitute"
            placeholder="Enter Institute Name"
            value={data.courseInstitute}
            name="courseInstitute"
            onChange={handleOnChange}
            className="input"
            required
          />
          <label htmlFor="courseYear">
            Year :
          </label>
          <input
            type="text"
            className="input"
            placeholder="Enter the Year"
            value={data.courseYear}
            name="courseYear"
            onChange={handleOnChange}
          />

          <label htmlFor="courseLogo" className="label">
            Course Logo :
          </label>
          <label htmlFor="courseLogo">
            <div className="upload-container">
              <div className="upload-content">
                <span className="upload-icon">
                  <FaCloudUploadAlt />
                </span>
                <p className="upload-text">Upload Courses Logo</p>
                <input
                  type="file"
                  id="courseLogo"
                  className="hidden"
                  onChange={handleUploadLogo}
                />
              </div>
            </div>
          </label>
          {uploadCourseLogo > 0 && uploadCourseLogo < 100 && (
            <label style={{color:'blue',textAlign:'center'}}>{`Upload is ${uploadCourseLogo}% done`}</label>
          )}

          <div>
            {data.courseLogo.length > 0 ? (
              <div className="image-preview">
                {data.courseLogo.map((el, index) => (
                  <div className="image-container" key={index}>
                    <img
                      src={el}
                      alt={el}
                      className="image"
                      onClick={() => {
                        setOpenFullScreenImage(true);
                        setFullScreenImage(el);
                      }}
                    />
                    <div
                      className="delete-icon"
                      onClick={() => handleDeleteLogo(index)}
                    >
                      <MdDelete />
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <p className="error-text">*Please Upload Courses Logo</p>
            )}
          </div>

          <label htmlFor="courseCertificates" className="label">
            Certificates:
          </label>
          <label htmlFor="courseCertificates">
            <div className="upload-container">
              <div className="upload-content">
                <span className="upload-icon">
                  <FaCloudUploadAlt />
                </span>
                <p className="upload-text">Upload Courses Certificates</p>
                <input
                  type="file"
                  id="courseCertificates"
                  className="hidden"
                  onChange={handleUploadCertificates}
                />
              </div>
            </div>
          </label>
          {uploadCourseCertificates > 0 && uploadCourseCertificates < 100 && (
            <label style={{color:'blue',textAlign:'center'}}>{`Upload is ${uploadCourseCertificates}% done`}</label>
          )}

          <div>
            {data.courseCertificates.length > 0 ? (
              <div className="image-preview">
                {data.courseCertificates.map((el, index) => (
                  <div className="image-container" key={index}>
                    <img
                      src={el}
                      alt={el}
                      className="image"
                      onClick={() => {
                        setOpenFullScreenImage(true);
                        setFullScreenImage(el);
                      }}
                    />
                    <div
                      className="delete-icon"
                      onClick={() => handleDeleteCertificates(index)}
                    >
                      <MdDelete />
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <p className="error-text">*Please Upload Courses Certificates</p>
            )}
          </div>
          
          <button className="submit-button" disabled={loading}>
            Add Courses
          </button>
        </form>
      </div>
      {openFullScreenImage && (
        <DisplayImage
          onClose={() => setOpenFullScreenImage(false)}
          imageUrl={fullScreenImage}
        />
      )}
    </div>
  );
};

export default UploadCourses;
